
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as dealsIFTKc_4509ep0rtTNBKprpxF5WiOYrYPNTzDtEzOp1iBMMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/deals.vue?macro=true";
import { default as indexWtDAcy0ch_456gWppSggQ1a5ZQZteoxCxjgr1MIiJzt90Meta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/index.vue?macro=true";
import { default as loginPCWU8QqamXtyCoZ6RG_45bsVpzh9_YT8sPKjKcgzL6PQcMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/login.vue?macro=true";
import { default as staffJlsESb1Dsdn1ntcik4TFKHF1BhF2jmF_zGAC6z25dpkMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/staff.vue?macro=true";
import { default as billingXONW3gsWmonjUP3L6fQzgXak12WVYnFauo5RnNcTmqoMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/billing.vue?macro=true";
import { default as clientsmZMKWjEaMJoKDd2LoQLx5Vq4QNkV5H5UoLNEYndCCFcMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/clients.vue?macro=true";
import { default as dealcal9R0hzmRNyF_45oZL0Njd7vn_citwiBVYC9_A2NcBuKLV0Meta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/dealcal.vue?macro=true";
import { default as profile3wU9wEd8uEHvE7yW7jsRPaIPryt3umve9fZ0LvBg_ckMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/profile.vue?macro=true";
import { default as registerrQt83h4oJJZW_7iHdzOhA5ILpDnmPDJBLfhpjTpIiBYMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/register.vue?macro=true";
import { default as servicespFMPb9maYw4_45UeVpYO3o9LTg6GRn1sv2HIEC1ELLhioMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/services.vue?macro=true";
import { default as timeline3iRPzNfTsiBAVA1UuFjwXVMjqZB_Tlf7uDWs6TlgSm4Meta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/timeline.vue?macro=true";
import { default as ps_45responseMBgOGa7nLWJDT7gKSYgaZelcpLuH2VybXzGcVVvecjMMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/ps-response.vue?macro=true";
import { default as email_45confirmrvzt39bX6pmM9ZhCC4_PKJ_y5RF0akTOmxJ7XqB9PW8Meta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/email-confirm.vue?macro=true";
import { default as email_45confirmedY_2bYgJPSbHN955ojevccRRPOeA5MC6YIibqKyZkEekMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/email-confirmed.vue?macro=true";
import { default as tariff_45inactiveIAMcBkyDuLFsWcSwL36Iw0YtNsCkh2Y1Rqj1JXzTphgMeta } from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/tariff-inactive.vue?macro=true";
export default [
  {
    name: "deals",
    path: "/deals",
    meta: {"middleware":["role-restrict","tariff-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/deals.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["role-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginPCWU8QqamXtyCoZ6RG_45bsVpzh9_YT8sPKjKcgzL6PQcMeta || {},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/login.vue")
  },
  {
    name: "staff",
    path: "/staff",
    meta: {"middleware":["role-restrict","tariff-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/staff.vue")
  },
  {
    name: "billing",
    path: "/billing",
    meta: {"middleware":["role-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/billing.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: {"middleware":["role-restrict","tariff-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/clients.vue")
  },
  {
    name: "dealcal",
    path: "/dealcal",
    meta: {"middleware":["role-restrict","tariff-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/dealcal.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/profile.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerrQt83h4oJJZW_7iHdzOhA5ILpDnmPDJBLfhpjTpIiBYMeta || {},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/register.vue")
  },
  {
    name: "services",
    path: "/services",
    meta: {"middleware":["role-restrict","tariff-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/services.vue")
  },
  {
    name: "timeline",
    path: "/timeline",
    meta: {"middleware":["role-restrict","tariff-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/timeline.vue")
  },
  {
    name: "ps-response",
    path: "/ps-response",
    meta: {"middleware":["role-restrict"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/ps-response.vue")
  },
  {
    name: "email-confirm",
    path: "/email-confirm",
    meta: {"middleware":["restrict-email-confirm"]},
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/email-confirm.vue")
  },
  {
    name: "email-confirmed",
    path: "/email-confirmed",
    meta: { ...(email_45confirmedY_2bYgJPSbHN955ojevccRRPOeA5MC6YIibqKyZkEekMeta || {}), ...{"middleware":["restrict-email-confirm"]} },
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/email-confirmed.vue")
  },
  {
    name: "tariff-inactive",
    path: "/tariff-inactive",
    component: () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/pages/tariff-inactive.vue")
  }
]